import React, { createContext, useContext, useState, ReactNode } from 'react';

interface LivePanelContextType {
  rightPanelCollapsed: boolean;
  setRightPanelCollapsed: (collapsed: boolean) => void;
  toggleRightPanel: () => void;
}

const LivePanelContext = createContext<LivePanelContextType | undefined>(
  undefined,
);

export const LivePanelProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [rightPanelCollapsed, setRightPanelCollapsed] = useState(false);

  const toggleRightPanel = () => {
    setRightPanelCollapsed((prev) => !prev);
  };

  return (
    <LivePanelContext.Provider
      value={{
        rightPanelCollapsed,
        setRightPanelCollapsed,
        toggleRightPanel,
      }}
    >
      {children}
    </LivePanelContext.Provider>
  );
};

export const useLivePanel = () => {
  const context = useContext(LivePanelContext);
  if (!context) {
    throw new Error('useLivePanel must be used within LivePanelProvider');
  }
  return context;
};
